var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilterSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_921",
    "data-name": "\\uC0AC\\uAC01\\uD615 921",
    width: 20,
    height: 17,
    transform: "translate(-0.152 -0.293)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2502",
    "data-name": "\\uADF8\\uB8F9 2502",
    transform: "translate(-71.848 4.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2501",
    "data-name": "\\uADF8\\uB8F9 2501",
    transform: "translate(72 -4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1695",
    "data-name": "\\uD328\\uC2A4 1695",
    d: "M3.357,343.049a1.676,1.676,0,0,1-1.678,1.674c-.463,0-1.678-.075-1.678-.075v-1.6a1.678,1.678,0,0,1,3.357,0",
    transform: "translate(0 -328.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1696",
    "data-name": "\\uD328\\uC2A4 1696",
    d: "M3.357,172.451a1.678,1.678,0,1,1-1.678-1.674,1.676,1.676,0,0,1,1.678,1.674",
    transform: "translate(0 -164.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1697",
    "data-name": "\\uD328\\uC2A4 1697",
    d: "M3.357,1.673A1.678,1.678,0,1,1,1.678,0,1.676,1.676,0,0,1,3.357,1.673",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1698",
    "data-name": "\\uD328\\uC2A4 1698",
    d: "M164.2,23.874h-13.52a.2.2,0,0,1-.2-.2V22.427a.2.2,0,0,1,.2-.2H164.2a.2.2,0,0,1,.2.2v1.248a.2.2,0,0,1-.2.2",
    transform: "translate(-144.7 -21.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1699",
    "data-name": "\\uD328\\uC2A4 1699",
    d: "M164.2,194.627h-13.52a.2.2,0,0,1-.2-.2V193.18a.2.2,0,0,1,.2-.2H164.2a.2.2,0,0,1,.2.2v1.248a.2.2,0,0,1-.2.2",
    transform: "translate(-144.7 -185.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1700",
    "data-name": "\\uD328\\uC2A4 1700",
    d: "M164.2,365.494h-13.52a.2.2,0,0,1-.2-.2v-1.248a.2.2,0,0,1,.2-.2H164.2a.2.2,0,0,1,.2.2v1.248a.2.2,0,0,1-.2.2",
    transform: "translate(-144.7 -349.92)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterSelected);
export default __webpack_public_path__ + "static/media/icon-Filter-Selected.7fd3ef159b895354a7a440a35b5b68b2.svg";
export { ForwardRef as ReactComponent };